import styled from 'styled-components';

import { Flex } from '../../base';

type BarChartSegment = {
  id: string;
  value: number;
  background: string;
};

type Props = {
  segments: BarChartSegment[];
  css?: StyledCss;
  total: number;
};

const MultiSegmentBar = (props: Props) => {
  return (
    <Style css={props.css}>
      {props.segments.map((seg, index, array) => {
        const accWidth = array.slice(0, index + 1).reduce((acc, cur) => {
          return acc + (cur.value / props.total) * 100;
        }, 0);
        return (
          <BarStyle
            key={seg.id}
            style={{
              position: 'absolute',
              zIndex: array.length - (index + 1),
              background: seg.background,
              width: `${accWidth}%`,
            }}
          />
        );
      })}
    </Style>
  );
};

type StyleProps = {
  css?: StyledCss;
};

const Style = styled(Flex)<StyleProps>`
  position: relative;
  border-radius: 8px;
  width: 100%;
  height: 8px;
  overflow: hidden;
  background-color: ${(props) => props.theme.colors.gray200};
  ${({ css }) => css && css};
`;

const BarStyle = styled.div`
  transition: all 0.2s;
  background-color: ${(props) => props.theme.colors.primary100};
  height: 100%;
  border-radius: 8px;

  &:first-child {
    transform: none;
  }
`;

export default MultiSegmentBar;
